import { observer } from 'mobx-react';
import { FC, ReactElement, memo } from 'react';
import Skeleton from 'react-loading-skeleton';
import { previousOrderModalStore } from '../../store/previousOrderModalStore';
import { Icons } from '~/assets/fonts/Icons/icons';
import { formatDate } from '~/utils/helpers';
import Icon from '~/view/components/Controls/Icon/Icon';
import './style.scss';

export const PreviousOrderModalProductInfo: FC = memo(
  observer((): ReactElement => {
    const { loading, order } = previousOrderModalStore;

    return (
      <div className="previous-order-modal-product-info">
        {loading ? (
          <Skeleton width={200} height={19.2} />
        ) : (
          <div className="d-flex flex-row">
            <Icon name={Icons.Calendar} size={18} />
            <p className="previous-order-modal-product-info__text">{formatDate(order?.created_at, {})}</p>
            <p className="previous-order-modal-product-info__text">{order?.delivery_type}</p>
          </div>
        )}
      </div>
    );
  })
);
